import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getOwner: 'client/owner',
      selectedClientId: 'client/selectedClientId',
      isLoadingClientDetails: 'client/isLoadingClientDetails',
    }),
    owner() {
      return this.getOwner(this.selectedClientId)
    },
    ownerName() {
      return this.owner?.ownerName
    },
    ownerPhone() {
      return this.owner?.ownerPhone
    },
  },
}
